// API Configuration
// This file handles different API URLs for development and production

const getApiUrl = () => {
  // Check if we're in production (built app)
  if (process.env.NODE_ENV === 'production') {
    // In production, use the backend server domain
    // Use HTTPS if frontend is HTTPS to avoid mixed content issues
    const isFrontendHttps = window.location.protocol === 'https:';
    return isFrontendHttps ? 'https://whatsb.affluentix.com' : 'http://whatsb.affluentix.com';
  }
  // In development, use localhost:5000
  return 'http://localhost:5000';
};

const getSocketUrl = () => {
  // Check if we're in production
  if (process.env.NODE_ENV === 'production') {
    // In production, use the backend server domain
    // Use HTTPS if frontend is HTTPS to avoid mixed content issues
    const isFrontendHttps = window.location.protocol === 'https:';
    return isFrontendHttps ? 'https://whatsb.affluentix.com' : 'http://whatsb.affluentix.com';
  }
  // In development, use localhost:5000
  return 'http://localhost:5000';
};

export const API_URL = getApiUrl();
export const SOCKET_URL = getSocketUrl();

export default {
  API_URL,
  SOCKET_URL
};

